import React from 'react'

const StoryVision:React.FC = () => {
  return (
    <section className='pt-20 md:pt-20 pb-16 flex items-center justify-center bg-gradient-to-b from-white to-[#f2f60352]'>
      <div className='container'>
        <div className='md:w-[77%] mx-auto mb-24'>
          <h2 className='text-darkText text-[32px] leading-[43.65px] text-center mb-10 md:px-[40px]'>Our Story</h2>
          <p className='text-textColor text-[20px] leading-[30px] text-center md:px-[120px]'>EXAM COMPASS was founded to address the challenges students face in preparing
            for JAMB exams. We provide tailored resources to help students achieve their
            academic dreams.</p>
        </div>

        <div className='md:w-[77%] mx-auto'>
          <h2 className='text-darkText text-[32px] leading-[43.65px] text-center mb-10 md:px-[40px]'>Our Vision</h2>
          <p className='text-textColor text-[20px] leading-[30px] text-center md:px-[120px]'>The vision of exam compassNG is to change the narrative that students aspiring to
            To be the best solution provider in the UTME preparatory field. Massively enhancing
            the improvement in the number of students with high scores in the UTME.</p>
        </div>
      </div>
    </section>
  )
}

export default StoryVision